import { onFormationChange } from '../admin/actions/playerActions';
import store from './store';

const updateFormation = (key, value, isLanding) => {
    const state = store.getState();
    store.dispatch(onFormationChange( key, value, state.playerIndex, isLanding ? state.playerLanding : state.playerFormation, isLanding))
}

export default updateFormation
